<template>
    <div class="col-lg-6 col-12" id="view_report_step">
        <div class="card card-congratulation-medal">
            <div v-if="userStore.userDashboard.IQ">
                <div v-if="userStore.userDashboard.IQ.pull_status_string == 'Success'">
                    <div class="card-body col-11">
                        <h5 class="text-primary">Congratulations
                            <span v-if="userStore.userDashboard.user != null"> {{ userStore.userDashboard.user.firstname }}</span>
                            <span v-else>Creditfixrr</span>
                        🎉</h5>
                        <p class="card-text font-small-4">You've successfully imported your Credit Report!</p>
                        <p class="card-text font-small-4">
                            Now that you've imported your <strong>Credit Report</strong>. Creditfixrr's Ai has created your <strong>Credit Analysis Report</strong>

                            as well as your very own <strong>Personalized Dispute Flow</strong> for you to follow.
                        </p>
                        <hr>
                        <div class="d-flex justify-content-center pt-1">
                            <a href="#" data-toggle="modal" data-target="#credit_analysis_modal_update" class=" mr-1 btn btn-sm btn-outline-primary waves-effect">
                                <span><i data-feather="activity"></i></span> Credit Analysis
                            </a>
                            <a href="#" data-toggle="modal" data-target="#dispute_process_modal_video" class="mr-1 btn btn-sm btn-outline-primary waves-effect">
                                <span><i data-feather="film"></i></span> Dispute Flow Tutorial
                            </a>
                            <a :href="$router.resolve({ name: 'dispute-center'}).href" type="submit" class="btn btn-sm btn-primary waves-effect waves-light">
                                <span><i data-feather="map"></i></span> Personalized Dispute Flow
                            </a>
                        </div>
                    </div>
                    <div class="">
                        <img src="https://pixinvent.com/demo/vuexy-bootstrap-laravel-admin-template/demo-2/images/illustration/badge.svg"
                            class="congratulation-medal pl-7">
                    </div>
                </div>
                
            </div>
            <div class="card-body" v-else>
                <h5 class="text-primary">Hey
                    <span v-if="userStore.userDashboard.user != null"> {{ userStore.userDashboard.user.firstname }}</span>
                    <span v-else>Creditfixrr</span>
                    👋</h5>
                    <p class="card-text font-small-4">
                    In order for you to begin removing those negative items from your Credit Report and improve your Credit Scores!

                    You must <strong>Import your Credit Report in Step 2</strong>.
                    </p>
                    <hr>
                    <div class="d-flex justify-content-center pt-1">
                        <a href="#" data-toggle="modal" data-target="#credit_analysis_modal_update" class=" mr-1 btn btn-sm btn-outline-primary waves-effect">
                            <span><i data-feather='activity'></i></span> Credit Analysis
                        </a>
                        <a href="#" data-toggle="modal" data-target="#dispute_process_modal_video" class="bt mr-1 btn-sm btn-outline-primary waves-effect">
                            <span><i data-feather="film"></i></span> Dispute Flow Overiew
                        </a>

                        <a :href="$router.resolve({ name: 'dispute-center'}).href" type="submit" class="btn btn-sm btn-primary waves-effect waves-light">
                            <span><i data-feather="map"></i></span> Personalized Dispute Flow
                        </a>
                    </div>
            </div>
        </div>
    </div>
</template>
<script>
import { useUserStore } from '../../../stores/UserStore.js'
export default{
    setup(){
        return {
            userStore:useUserStore()
        }
    },
    methods:{}
}
</script>
